import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { toast } from "sonner";
import { submitLead } from "../../lib/api";
import { Field, inputCls, Honeypot } from "./fields";
import { CTAButton } from "../common/CTAButton";
import { careerAreas } from "../../data/content";

const schema = z.object({
    name: z.string().min(2, "Enter your name"),
    email: z.string().email("Enter a valid email"),
    mobile: z.string().min(8, "Enter a valid mobile number"),
    area: z.string().optional(),
    experience: z.string().optional(),
    resume_url: z.string().optional(),
    message: z.string().optional(),
    honeypot: z.string().optional(),
});

export const CareerForm = () => {
    const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({ resolver: zodResolver(schema) });

    const onSubmit = async (values) => {
        try {
            await submitLead("career", values);
            toast.success("Application submitted. Our HR team will review your profile.");
            reset();
        } catch (e) {
            toast.error("Something went wrong. Please try again.");
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} data-testid="career-form" className="space-y-5">
            <Honeypot register={register} />
            <div className="grid sm:grid-cols-2 gap-5">
                <Field label="Full Name" required error={errors.name?.message}>
                    <input className={inputCls} placeholder="Your name" data-testid="cr-name" {...register("name")} />
                </Field>
                <Field label="Email" required error={errors.email?.message}>
                    <input className={inputCls} placeholder="name@email.com" data-testid="cr-email" {...register("email")} />
                </Field>
                <Field label="Mobile Number" required error={errors.mobile?.message}>
                    <input className={inputCls} placeholder="+91" data-testid="cr-mobile" {...register("mobile")} />
                </Field>
                <Field label="Preferred Area">
                    <select className={inputCls} data-testid="cr-area" defaultValue="" {...register("area")}>
                        <option value="" disabled>Select area</option>
                        {careerAreas.map((a) => <option key={a} value={a}>{a}</option>)}
                    </select>
                </Field>
                <Field label="Total Experience">
                    <input className={inputCls} placeholder="e.g. 3 years" data-testid="cr-exp" {...register("experience")} />
                </Field>
                <Field label="Resume Link (Drive / URL)">
                    <input className={inputCls} placeholder="https://..." data-testid="cr-resume" {...register("resume_url")} />
                </Field>
            </div>
            <Field label="Message">
                <textarea rows={4} className={inputCls} placeholder="Tell us about yourself" data-testid="cr-message" {...register("message")} />
            </Field>
            <CTAButton type="submit" variant="primary" arrow disabled={isSubmitting} data-testid="cr-submit" className="w-full sm:w-auto disabled:opacity-60">
                {isSubmitting ? "Submitting..." : "Submit Your Resume"}
            </CTAButton>
        </form>
    );
};
